<template>
    <popup-overlay>
        <popup-wrapper>
            <button class="modal-popup__close" :aria-lable="$t('POPUP_CLOSE')" @click.prevent="close">
            </button>

            <div class="cz2__modal-popup__header text-base lg:text-2xl lg:tracking-loose">
                {{$t('POPUP_LEAVING_HEADER')}}
            </div>

            <div class="cz2__modal-popup__body-copy text-sm">
                {{$t('POPUP_LEAVING_BODY')}}
            </div>

            <primary-button  @click.prevent="confirm">
                {{$t('POPUP_LEAVING_OK')}}
            </primary-button>
        </popup-wrapper>
    </popup-overlay>
</template>

<script>
    import PopupOverlay from './PopupOverlay.vue';
    import PopupWrapper from './PopupWrapper.vue';
    import PrimaryButton from '../buttons/PrimaryButton.vue';

    export default {
        components: {
            PrimaryButton,
            PopupOverlay,
            PopupWrapper,
        },
        computed: {
            /**
             * Current view controller.
             */
            viewController() {
                return this.$store.state.customizer.viewController;
            },
        },
        methods: {
            close() {
                this.$store.dispatch('showExitConfirmation', false);
            },

            cancel() {
                this.$store.dispatch('showExitConfirmation', false);
            },

            confirm() {
                if (this.viewController.blueprint.custom['v-stocked-handle']) {
                    // Redirect to the product page.
                    window.location.href = `/products/${this.viewController.blueprint.custom['v-stocked-handle']}`;
                } else if (this.viewController.blueprint.custom['v-handle']) {
                    // Redirect to the product page.
                    window.location.href = `/products/${this.viewController.blueprint.custom['v-handle']}`;
                } else {
                    this.$store.dispatch('globalCancel');
                }

                this.$store.dispatch('showExitConfirmation', false);
            },

            confirmSave() {
                this.$store.dispatch('saveWishlist', {
                    cancelAfter: true,
                });
            },
        },
    };
</script>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__leaving-save {
            margin-top: 30px;
        }

        .cz2__leaving-save__button {
            text-align: center;
        }

        .cz2__leaving-save__button-icon {
            display: block;

            width: $icon-size;
            height: $icon-size;

            margin: 0 auto 10px;

            background: transparent url(../../assets/heart@2x.png) no-repeat center/contain;
        }

        .cz2__leaving-save__button-text {
            display: block;

            white-space: nowrap;
        }
    }
</style>
